<div class="title">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.API_NO_ENTITY_TRIGGER.TITLE' | translate }}
</div>

<glxy-form-field class="field" [disabled]="true">
  <glxy-label>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.API_NO_ENTITY_TRIGGER.WEBHOOK_URL' | translate }}</glxy-label>
  <div class="webhook-url-field" insideInputWrapper>
    <input class="webhook-url-input" disabled="true" type="text" value="{{ url }}" matInput />
    <button [cdkCopyToClipboard]="url" class="copy-button" mat-button>
      <mat-icon>content_copy</mat-icon>
      {{ 'COMMON.ACTION_LABELS.COPY' | translate }}
    </button>
  </div>
  <glxy-hint>
    <ng-container *ngIf="!contextConfig.whitelabel; else smbContext">
      <div
        [innerHtml]="
          'AUTOMATIONS.EDITOR.TRIGGERS.API_NO_ENTITY_TRIGGER.API_DOCS_NOT_WHITELABELLED'
            | translate: { automationId: automationId }
            | iTrustThisHtml
        "
      ></div>
    </ng-container>
    <ng-template #smbContext>
      <div
        [innerHtml]="
          'AUTOMATIONS.EDITOR.TRIGGERS.API_NO_ENTITY_TRIGGER.API_DOCS_WHITELABELLED'
            | translate: { automationId: automationId }
            | iTrustThisHtml
        "
      ></div>
    </ng-template>
  </glxy-hint>
</glxy-form-field>
